import boostBox from './boostBox.png';

export type BoostBoxProps = JSX.IntrinsicElements['img'];
export const BoostBox = (props: BoostBoxProps) => (
  <img src={boostBox} alt="boost box" width={92} height={92} {...props} />
);
